/**
 * @param c customer details from backend.
 */
export function from(c) {
    return {
        email: c.email,
        firstname: c.first_name,
        name: c.last_name,
        phonecode: c.phonecode,
        phonenumber: c.phone
    };
}
